<template>
  <div class="p-3">
    <div class="my-recommendations d-inline-block">
      <h1>{{ texts.recommendation }}</h1>
      <p class="mb-4">{{ texts.recommendationDescription }}</p>
      <hr class="mb-3 separator" />
      <div class="row">
        <div class="test-block mb-5 d-flex flex-column" v-for="test in tests" :key="test.id">
          <div
            class="test-image center-cover mb-3 d-flex align-items-center justify-content-center"
            v-bind:class="{ opacity4: !test.created }"
            v-bind:style="{ 'background-image': `url(${test.form.thumbnail})` }"
          >
            <svg
              v-if="test.created"
              width="86"
              height="86"
              viewBox="0 0 86 86"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M21 40.5L37.5 57L65.5 29" stroke="white" stroke-width="8" />
              <circle cx="43" cy="43" r="39" stroke="white" stroke-width="8" />
            </svg>
          </div>
          <div class="flex-grow">
            <label class="text-center font-weight-bold d-block">{{ test.form.name }}</label>
            <p class="text-center" v-if="test.created">
              {{ texts.made }} {{ test.created | moment("YYYY-MM-DD") }}
            </p>
          </div>
          <router-link v-if="test.created" :to="`/result/${test.id}?lang=${lang}`">
            <button class="btn btn-secondary btn-sm full">{{ texts.seeYourResult }}</button>
          </router-link>
          <button class="btn btn-secondary btn-sm full" v-else>{{ texts.doTest }}</button>
        </div>

        <div
          class="test-block mb-5 d-flex flex-column"
          v-for="test in tests_not_finished"
          :key="test.id"
        >
          <div
            class="
              test-image center-cover mb-3
              d-flex align-items-center
              justify-content-center opacity4
            "
            v-bind:style="{ 'background-image': `url(${test.thumbnail})` }"
          />
          <div class="flex-grow">
            <label class="text-center font-weight-bold d-block">{{ test.name }}</label>
          </div>
          <a
            :href="test.test_url"
            target="_top"
            :id="`not-made-test-${test.id}`"
            style="display:none"
          />
          <button
            class="btn btn-secondary btn-sm full"
            v-on:click="goToTestUrl(`not-made-test-${test.id}`)"
          >
            {{ texts.doTest }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myaccount',
  data() {
    return {
      tests: [],
      tests_not_finished: [],
      texts: {},
      lang: this.$route.query.lang || 'sv',
    };
  },
  mounted() {
    const { lang } = this.$route.query;
    this.$http
      .get(`/api/result/${this.$route.params.id}/?lang=${lang || 'sv'}`)
      .then(response => response.data)
      .then((response) => {
        this.tests = response.finished_forms;
        this.tests_not_finished = response.not_finished_forms;
        this.texts = response.texts;
      });
  },
  methods: {
    goToTestUrl(id) {
      document.getElementById(id).click();
    },
  },
};
</script>
